import { Game, GamesResponse } from '@/types/GameType';
import { AxiosRequestConfig } from 'axios';
import http from './api-client';

const apiEndpoint = '/games';

/**
 * Fetches the list of games from the API.
 * @param signal - AbortSignal for canceling the request
 * @param config - Configuration for the HTTP request
 * @returns Promise containing the game list
 */
export const getGames = async (config?: AxiosRequestConfig) =>
    await http
        .get<GamesResponse>(apiEndpoint, { ...config })
        .then((res) => res.data);

/**
 * Fetches the list of games from the API.
 * @param config - Configuration for the HTTP request
 * @returns Promise containing the game list
 */
export const getGame = async (id: number | string, config?: AxiosRequestConfig) =>
    await http
        .get<Game>(`${apiEndpoint}/${id}`, { ...config })
        .then((res) => res.data);
